import { type InputHTMLAttributes, forwardRef, useId } from 'react';
import { cn } from '@/lib/utils';
import { Field, controlClasses } from './field';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  sizeVariant?: 'sm' | 'md';
  wrapperClassName?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, wrapperClassName, label, error, helperText, sizeVariant = 'md', type = 'text', ...props }, ref) => {
    const generatedId = useId();
    const inputId = props.id ?? generatedId;
    const descriptionId = error || helperText ? `${inputId}-description` : undefined;

    return (
      <Field id={inputId} label={label} error={error} helperText={helperText} descriptionId={descriptionId} className={wrapperClassName}>
        <input
          ref={ref}
          type={type}
          id={inputId}
          aria-invalid={error ? true : undefined}
          aria-describedby={descriptionId}
          className={cn(controlClasses, sizeVariant === 'sm' ? 'h-8 px-2.5 text-[13px]' : 'h-9 px-3', className)}
          {...props}
        />
      </Field>
    );
  }
);

Input.displayName = 'Input';
